export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-base">
                瓜
              </span>
              <span className="font-heading font-bold text-xl text-background-50">
                五一吃瓜网
              </span>
            </div>
            <p className="text-background-300 text-sm leading-relaxed mb-4 max-w-sm">
              五一吃瓜网是一个专注于娱乐八卦与热点资讯的综合平台，覆盖最新吃瓜网站动态、明星爆料、综艺热议与网络热点追踪，为吃瓜爱好者提供一站式资讯服务。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-vidicon-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading font-semibold text-background-100 text-sm mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <a href="#about" className="text-background-400 text-sm hover:text-accent-400 transition-colors cursor-pointer">关于平台</a>
              <a href="#faq" className="text-background-400 text-sm hover:text-accent-400 transition-colors cursor-pointer">常见问题</a>
              <a href="#contact" className="text-background-400 text-sm hover:text-accent-400 transition-colors cursor-pointer">联系我们</a>
              <a href="#index" className="text-background-400 text-sm hover:text-accent-400 transition-colors cursor-pointer">主题索引</a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading font-semibold text-background-100 text-sm mb-4">
              热门栏目
            </h4>
            <div className="flex flex-col gap-2">
              <a href="#topics" className="text-background-400 text-sm hover:text-accent-400 transition-colors cursor-pointer">话题热榜</a>
              <a href="#comments" className="text-background-400 text-sm hover:text-accent-400 transition-colors cursor-pointer">读者热评</a>
              <a href="#ranking" className="text-background-400 text-sm hover:text-accent-400 transition-colors cursor-pointer">热度排行</a>
              <a href="#updates" className="text-background-400 text-sm hover:text-accent-400 transition-colors cursor-pointer">最新动态</a>
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading font-semibold text-background-100 text-sm mb-4">
              合作伙伴
            </h4>
            <p className="text-background-500 text-sm leading-relaxed">
              我们与多家优质内容平台保持紧密合作，共同为用户提供更丰富的吃瓜资讯与娱乐内容体验。合作详情敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} 五一吃瓜网 版权所有
          </p>
          <p className="text-background-600 text-xs">
            五一吃瓜网 — 最新最全的娱乐八卦资讯平台
          </p>
        </div>
      </div>
    </footer>
  );
}